import { render } from "./App.vue?vue&type=template&id=af01cd12&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=af01cd12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af01cd12"

export default script